import React from "react"
import styled from "styled-components"
import Countdown from "react-countdown"

import "react-toastify/dist/ReactToastify.css"

import Decoration from "./Decoration"
import PositionAndWidth from "./PositionAndWidth"

import MintButton from "./MintButton"

import { BGWrapper, H1, H3 } from "./UIStyle/UIstyle"
import { theme } from "@/containers/LuckyBagNew2023/Views/mixin"
import NextImg from "@/common/components/NextImg/index"
import NFTBox from "./animationIMG/NFTBox"
// images
import norns from "@/common/assets/image/lucky-bag-2023/logos/norns.webp"
import domhie from "@/common/assets/image/lucky-bag-2023/logos/domhie.webp"
import kuaicher from "@/common/assets/image/lucky-bag-2023/logos/kuaicher.webp"
import beast from "@/common/assets/image/lucky-bag-2023/logos/beast.webp"
import ok from "@/common/assets/image/lucky-bag-2023/logos/ok.webp"

export default React.memo(function KeyVisualNew({
  eventEnd,
  eventDay1Start,
  totalSupply,
  maxDailyMintAmount,
  minted,
  mintPeriod,
  loading,
  setMintPeriod,
  dayS,
  dayE,
  setLoading,
  setMinted,
  setShowPopup,
  setPopupContent,
  left
}) {
  const renderer = ({ total, days, hours, minutes, seconds }) => {
    setMintPeriod(!total)
    return (
      <>
        <MintButton
          total={total}
          eventEnd={eventEnd}
          eventDay1Start={eventDay1Start}
          totalSupply={totalSupply}
          maxDailyMintAmount={maxDailyMintAmount}
          minted={minted}
          setMinted={setMinted}
          mintPeriod={mintPeriod}
          loading={loading}
          days={days}
          hours={hours}
          minutes={minutes}
          seconds={seconds}
          setLoading={setLoading}
          setShowPopup={setShowPopup}
          setPopupContent={setPopupContent}
          dayS={dayS}
          dayE={dayE}
        />
      </>
    )
  }

  return (
    <>
      <Wrapper start id="top" bg={theme.bgLinearBottom}>
        <ContentWrapper>
          <BGWrapper>
            <PositionAndWidth
              d={{ width: "10%", b: "0%", l: "20%" }}
              m={{ width: "clamp(30px,40%,120px)", b: "-1%", r: "0%" }}
            >
              <Decoration
                type="blobman1"
                animation="updown"
                time={12}
                delay={0}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "10%", b: "0%", l: "-3%" }}
              m={{ width: "clamp(30px,40%,120px)", b: "0%", l: "-3%" }}
            >
              <Decoration
                type="blobman2"
                animation="updown"
                time={12}
                delay={6}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "8%", b: "0px", r: "0%" }}
              m={{ width: "0%", b: "0px", r: "10%" }}
            >
              <Decoration
                type="blobman1"
                animation="updown"
                time={12}
                delay={4}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "4%", t: "15%", r: "-2%" }}
              m={{ width: "8%", t: "40%", l: "-4%" }}
            >
              <Decoration
                type="circle"
                animation="updown"
                time={12}
                delay={3}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "1%", t: "50%", r: "-0.5%" }}
              m={{ width: "3%", t: "50%", r: "-1.5%" }}
            >
              <Decoration
                type="Scircle"
                animation="updown"
                time={12}
                delay={9}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "1.5%", b: "-0.75%", l: "40%" }}
              m={{ width: "3%", b: "-0%", l: "40%" }}
            >
              <Decoration
                type="Scircle"
                animation="updown"
                time={12}
                delay={2}
              />
            </PositionAndWidth>
            <PositionAndWidth
              d={{ width: "40px", b: "0", l: "calc(50% - 20px)" }}
              m={{ width: "40px", b: "0", l: "calc(50% - 20px)" }}
            >
              <Decoration type="Arrow" animation="updown" time={2} delay={0} />
            </PositionAndWidth>
          </BGWrapper>
          <LeftWrapper>
            <TitleText>
              <H3>3/31~4/7 狂歡兒童節</H3>
              <Titles>
                <H1>天天領 NFT、 拿好禮</H1>
                <H1>
                  再抽 <span>萬元精選大獎 !</span>
                </H1>
              </Titles>
            </TitleText>
            <ButtonWrapper>
              <Countdown date={dayS} renderer={renderer} />
            </ButtonWrapper>

            <LogosWrapper>
              <Logo>
                <NextImg src={norns} />
              </Logo>
              <Logo>
                <NextImg src={domhie} />
              </Logo>
              <Logo>
                <NextImg src={kuaicher} />
              </Logo>
              <Logo>
                <NextImg src={beast} />
              </Logo>
              <Logo>
                <NextImg src={ok} />
              </Logo>
            </LogosWrapper>
          </LeftWrapper>
          <RightWrapper>
            <HeroWrapper>
              <NFTBox />
            </HeroWrapper>
          </RightWrapper>
        </ContentWrapper>
      </Wrapper>
      <MobileLOGOsWrapper>
        <Logo>
          <NextImg src={norns} />
        </Logo>
        <Logo>
          <NextImg src={domhie} />
        </Logo>
        <Logo>
          <NextImg src={kuaicher} />
        </Logo>
        <Logo>
          <NextImg src={beast} />
        </Logo>
        <Logo>
          <NextImg src={ok} />
        </Logo>
      </MobileLOGOsWrapper>
    </>
  )
})

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  padding: 80px 60px 60px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ bg }) => bg};
  height: clamp(750px, 100vh, 1000px);
  @media (${theme.xl}) {
    height: clamp(750px, 100%, 1000px);
  }
  @media (${theme.md}) {
    height: clamp(100vh, 100%, 1000px);
    padding: 80px 20px 50px 20px;
  }
`

const ContentWrapper = styled.div`
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 73px;
  width: 100%;
  max-width: 1600px;
  height: 100%;
  gap: 40px;
  padding: 60px 60px 60px 60px;
  align-items: center;
  justify-content: start;
  @media (${theme.xl}) {
    padding: 30px 30px 30px 30px;
    border-radius: 36px;
    justify-content: center;
    align-items: center;
    /* min-height: calc(100vh - 140px); */
  }
  @media (${theme.lg}) {
    padding: 30px 30px 80px 30px;
    gap: 0px;
    border-radius: 36px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  @media (${theme.md}) {
    padding: 40px 20px 80px 20px;
    /* min-height: calc(100vh - 120px); */
    gap: 20px;
  }
`

const LeftWrapper = styled.div`
  text-align: start;
  display: flex;
  flex: 1.2;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 24px;
  border-radius: 50px;
  z-index: 30;
  order: 0;
  @media (${theme.lg}) {
    padding: 0px 0px;
    justify-content: start;
    order: 2;
  }
  @media (${theme.md}) {
    padding: 0px;
    width: 100%;
    order: 2;
    justify-content: center;
    align-items: center;
  }
  @media (${theme.sm}) {
    width: 100%;
  }
`
const TitleText = styled.div`
  font-family: "Barlow", "Noto Sans TC", sans-serif;
  text-align: start;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  @media (${theme.md}) {
    align-items: center;
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-content: center;
  gap: 24px;
  @media (${theme.md}) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`
const LogosWrapper = styled.div`
  display: grid;
  width: 100%;
  gap: 8px;
  justify-content: center;
  grid-template-columns: repeat(5, minmax(80px, 135px));
  @media (${theme.xl}) {
    grid-template-columns: repeat(5, minmax(80px, 100px));
  }
  @media (${theme.md}) {
    display: none;
  }
`

const Logo = styled.div`
  width: 100%;
  img {
    border-radius: 8px;
    overflow: hidden;
  }
`

const Titles = styled.div`
  @media (${theme.lg}) {
    display: flex;
    gap: 12px;
  }
  @media (${theme.md}) {
    flex-direction: column;
    gap: 0;
    align-items: center;
    justify-content: center;
  }
`
const A = styled.div``

const RightWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  flex: 1;
  order: 0;

  @media (${theme.xl}) {
    flex: 0.8;
  }
  @media (${theme.lg}) {
    width: 100%;
    flex: 1;
    padding: 0;
  }

  @media (${theme.md}) {
    position: relative;
    width: calc(100% + 0px);
    padding: 0px;
  }
`

const HeroWrapper = styled.div`
  width: 100%;
  @media (${theme.lg}) {
    max-width: 400px;
  }
  @media (${theme.md}) {
    max-width: 350px;
  }
  @media (${theme.sm}) {
    max-width: 350px;
  }
`
const B = styled.div``

const MobileLOGOsWrapper = styled.div`
  display: none;
  @media (${theme.md}) {
    background-color: ${theme.bgBlue};
    display: grid;
    width: 100%;
    gap: 8px;
    justify-content: center;
    grid-template-columns: repeat(auto-fit, minmax(80px, 100px));
    /* display: none; */
  }
`
